export interface BatchSchoolStatisticsLendRequest {
  lendDateFrom: string
  lendDateTo: string
  lendTitle: string
  lendType: string[]
  lendBranchCodeFrom: string
  lendBranchCodeTo: string
  placeCodeFrom: string
  placeCodeTo: string
  gradeFrom: string
  gradeTo: string
  classForm: string
  classTo: string
  userIdFrom: string
  userIdTo: string
  interlibraryLoanCodeFrom: string
  interlibraryLoanCodeTo: string
  yearAgeEnabled: boolean
  xItem: string
  yItem1: string
  yCheck1: boolean[]
  yItem2: string
  yCheck2: boolean[]
  yItem3: string
  yCheck3: boolean[]
  yItem4: string
  yCheck4: boolean[]
  bookCount: boolean
  personCount: boolean
  actualPersonCount: boolean
  displayFullName: boolean
  lendMemo: string
  batchType: string
}

export function BatchSchoolStatisticsLendRequestToJSON(
  value: BatchSchoolStatisticsLendRequest
): any {
  return {
    lend_date_from: value.lendDateFrom,
    lend_date_to: value.lendDateTo,
    title: value.lendTitle,
    lend_type: value.lendType,
    lend_branch_code_from: value.lendBranchCodeFrom,
    lend_branch_code_to: value.lendBranchCodeTo,
    place_code_from: value.placeCodeFrom,
    place_code_to: value.placeCodeTo,
    grade_from: value.gradeFrom,
    grade_to: value.gradeTo,
    class_from: value.classForm,
    class_to: value.classTo,
    user_id_from: value.userIdFrom,
    user_id_to: value.userIdTo,
    interlibrary_loan_code_from: value.interlibraryLoanCodeFrom,
    interlibrary_loan_code_to: value.interlibraryLoanCodeTo,
    year_age_enabled: value.yearAgeEnabled,
    x_item: value.xItem,
    y_item1: value.yItem1,
    y_check1: value.yCheck1,
    y_item2: value.yItem2,
    y_check2: value.yCheck2,
    y_item3: value.yItem3,
    y_check3: value.yCheck3,
    y_item4: value.yItem4,
    y_check4: value.yCheck4,
    book_count: value.bookCount,
    person_count: value.personCount,
    actual_person_count: value.actualPersonCount,
    display_full_name: value.displayFullName,
    memo: value.lendMemo,
    batch_type: value.batchType
  }
}
